import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./Container/pages/Home/Home";
import WhatsNewDetail from "./Container/pages/WhatsNewDetail";
import PhotoGallery from "./Container/pages/GalleryPages/PhotoGallery";
import FooterNavPage from "./Container/pages/FooterNavPages/FooterNavPage";
import MinisterDetailPage from "./Container/pages/Home/MinisterDetailPage";
import ScreenReader from "./Container/pages/ScreenReader";
import FooterTopCategory from "./Container/pages/FooterTopCategory";
import CourtLinkPages from "./Container/pages/CourtLinkPages";
import CalendarPage from "./Container/pages/CalendarPage";
import PresentMembersPage from "./Container/pages/PresentMembers/PresentMembersPage";
import MainMenuRoutes from "./Shared/Routes/MainMenuRoutes";
import FooterMenuRoutes from "./Shared/Routes/FooterMenuRoutes";
import CmsMenuRoutes from "./Shared/Routes/CmsMenuRoutes";

const AppRouting = ({ benchId, benchName }) => {
  return (
    <>
      <MainMenuRoutes benchId={benchId} />
      <FooterMenuRoutes benchId={benchId} />
      <CmsMenuRoutes benchId={benchId} />
      <Routes>
        {/* Main Menu */}
        <Route
          path=""
          element={<Home benchId={benchId} benchName={benchName} />}
        ></Route>
        <Route path="court-links" element={<CourtLinkPages />} />
        <Route
          path="calendar-detail"
          element={<CalendarPage benchId={benchId} />}
        />
        <Route
          path="present-members"
          element={<PresentMembersPage benchId={benchId} />}
        />
        <Route
          path="photos-gallery"
          element={<PhotoGallery benchId={benchId} />}
        />

        <Route
          path="tenders"
          element={
            <FooterNavPage
              benchId={benchId}
              menuPageId={1}
              pageTitle="Tender / Notices"
            />
          }
        />
        <Route
          path="policies"
          element={
            <FooterNavPage
              benchId={benchId}
              menuPageId={2}
              pageTitle="Policies / Circulars"
            />
          }
        />
        <Route
          path="misc-docs"
          element={
            <FooterNavPage
              benchId={benchId}
              menuPageId={3}
              pageTitle=" Miscellaneous Documents / Letters"
            />
          }
        />

        <Route
          path="vacancies"
          element={
            <FooterTopCategory
              benchId={benchId}
              pageTitle={"Vacancies"}
              apicategory={"vacancies"}
            />
          }
        />

        <Route
          path="screenreader"
          element={<ScreenReader benchId={benchId} />}
        />

        {/* other detail pages */}
        <Route
          path="whats-new"
          element={<WhatsNewDetail benchId={benchId} />}
        ></Route>

        <Route
          path="minister-detail-page"
          element={<MinisterDetailPage benchId={benchId} />}
        />
        {/* <Route path="*" element={<UnderDevelopment />} /> */}
      </Routes>
    </>
  );
};

export default AppRouting;
